import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

interface Props {}

const Root = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
  position: relative;
`;

const Container = styled.div`
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
  position: relative;
`;

const Content = styled.div`
  flex: 1 1 auto;
  height: 100%;
  overflow: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
  padding-top: 65px;
`;

const UnauthLayout: React.FC<Props> = (props) => {
  return (
    <Root>
      <Wrapper>
        <Container>
          <Content>
            <Outlet />
          </Content>
        </Container>
      </Wrapper>
    </Root>
  );
};

export default UnauthLayout;
